// import { useEffect } from "react";
import DashboardService from "../Service/API/Dashboard/DashboardService";
import { addDashboard, getDashboard, getRefreshToken, getThemeState } from "../Service/Variables/Common";
import { CatchError } from "../Service/Exceptions/exceptions";
import { useNavigate } from "react-router-dom";
import { useState, useEffect, useCallback } from "react";
import { TopLoader } from "../Component/MiscComponent/PrimitiveComponent";
import { renderContent } from "./Dashboard/RenderContent";
import { CustomerSidebar } from "../Component/Sidebar/CustomerSidebar";
import { CustomerHeader } from "../Component/Header/CustomerHeader";
import { BottomNavbar } from "../Component/Navbars/BottomNavbar";


function DashboardPages() {
    const defaultMode = 'inv'
    const navigation = useNavigate()
    const refreshToken = getRefreshToken()
    const [mode, setMode] = useState(defaultMode);
    const [dark, setDark] = useState(getThemeState());
    const [tab, setTab] = useState("dashboard");
    const [loading, setLoading] = useState(true);
    const [tabLoading, setTabLoading] = useState(false);
    const [sidebarOpen, setSidebar] = useState(false);

    const [dashboardState, setDashboardState] = useState(getDashboard())

    const fetch = useCallback(async() => {
        try {
            // setLoading(true)
            const dashboardService = new DashboardService()
            const dashboard = await dashboardService.loadDashboard()
            const dash = dashboard.data
            // console.log(dash)
            addDashboard(dash)
            setDashboardState(dash)
            setMode(dash?.type ?? defaultMode)
            // setLoading(false)
        } catch (error) {
            // setLoading(false)
            return CatchError(error, navigation, refreshToken)
        }
    }, [navigation, refreshToken])

    useEffect(() => {
        fetch()

        const intervalId = setInterval(fetch, 5000);

        return () => clearInterval(intervalId);
    }, [fetch])

    // Dark Mode
    useEffect(() => {
        document.documentElement.setAttribute("data-theme", dark ? "dark" : "light");
        try {
            localStorage.setItem(
                "isp-dark",
                dark
                ? "1" : "0"
            );
        } catch {}
    }, [dark]);

    // Initial load
    useEffect(() => {
        const t = setTimeout(() => setLoading(false), 1800);
        return () => clearTimeout(t);
    }, []);

    const cp = loading ? null : dashboardState.currentPeriod;
    const isPsb = cp?.type === "psb";
    const isPaid = isPsb ? (
        cp.paid === true || cp.status === "paid" )
        : cp?.paidStatus;

    const navigate = useCallback((key) => {
        if (key === tab) return;
        setTabLoading(true);
        setTab(key);
        setSidebar(false);
        setTimeout(() => setTabLoading(false), 850);
    }, [tab]);

    const changeMode = useCallback((m) => {
        if (m === mode) return;
        setTabLoading(true);
        setMode(m);
        setTimeout(() => setTabLoading(false), 850);
    }, [mode]);

    return (
        <>
        <TopLoader on={loading || tabLoading} />

        <div className="app-wrap">
            {/* Sidebar backdrop mobile */}
            {sidebarOpen
            && <div
                    className="sidebar-backdrop d-lg-none"
                    onClick={() => setSidebar(false)}
                />
            }

            {/* Sidebar */}
            <CustomerSidebar
                loading = {loading}
                sidebarOpen = {sidebarOpen}
                mode = {mode}
                isPaid = {isPaid}
                data = {dashboardState}
                changeMode = {changeMode}
                navigate = {navigate}
                tab = {tab}
            />

            <div className="main-col">
                {/* Header */}
                <CustomerHeader
                    loading = {loading}
                    tabLoading = {tabLoading}
                    isPaid = {isPaid}
                    isPsb = {isPsb}
                    data = {dashboardState}
                    dark = {dark}
                    setDark = {setDark}
                    tab = {tab}
                    setSidebar = {setSidebar}
                />

                {/* Page body */}
                <main className="page-body">
                    <div className={
                        !loading && !tabLoading
                        ? "anim-fade-up"
                        : ""}
                        key={`${tab}-${mode}-${loading}-${tabLoading}`}>
                    {renderContent(loading, tabLoading, tab, dashboardState, navigate)}
                    </div>
                </main>
            </div>
        </div>


        {/* BOTTOM NAV BAR */}
        <BottomNavbar
            tab = {tab}
            navigate = {navigate}
            isPaid = {isPaid}
            loading = {loading}
            data = {dashboardState}
        />
        </>
    );
}

export default DashboardPages;
